import React from 'react';

import CreateEditEventFormUi from '../CreateEditEventFormUi';

const CreateEventDialog = (props) => {
  const {
    openDialog,
    event,
    isSaving,
    branchId,
    openCreateEventDialog,
    onHandleInputChange,
    submitEvent,
    loggedInUser,
    openDocumentListDialog,
    documents
  } = props;

  const handleSubmit = (e) => {
    e.preventDefault();
    event.branchId = branchId;
    event.departmentId = 1;
    submitEvent(event);
  };

  return (
    <React.Fragment>
      <CreateEditEventFormUi
        openDialog={openDialog}
        isSaving={isSaving}
        onHandleInputChange={onHandleInputChange}
        openCreateEventDialog={openCreateEventDialog}
        handleSubmit={handleSubmit}
        title="Create New Event"
        event={event}
        documents={documents}
        canEditDocuments={true}
        openDocumentListDialog={openDocumentListDialog}
      />
    </React.Fragment>
  );
};

export default CreateEventDialog;
